<template>
  <el-form :model="agent" ref="agent" style="min-width: 300px;max-width: 600px;">
    <el-form-item label="公司名称" label-width="78px">
      <el-input type="text" v-model="agent.companyName"></el-input>
    </el-form-item>
    <el-form-item label="姓名" label-width="78px">
      <el-input type="text" v-model="agent.name"></el-input>
    </el-form-item>
    <el-form-item label="手机号" label-width="78px">
      <el-input type="number" v-model="agent.phone" readonly></el-input>
      <div class="tips"><i>敏感信息，暂不支持修改</i></div>
    </el-form-item>
    <el-form-item label="地址" label-width="78px">
      <el-cascader ref="location" v-model="agentLocation" :props="agentLocations" @change="locationChangeHandler"></el-cascader>
      <el-input type="text" v-model="agent.address"></el-input>
    </el-form-item>
    <el-form-item label="管辖区域" label-width="78px">
      <el-input type="text" v-model="agent.manageRegion" readonly></el-input>
    </el-form-item>
    <el-button type="primary" @click="saveAgent">确定</el-button>
  </el-form>
</template>

<script>
export default {
  name: "服务商信息",
  props: {
    currentUser: {
      type: Object
    }
  },
  data() {
    return {
      agent: {},
      agentLocations: [],
      agentLocation: null
    }
  },
  methods: {
    get() {
      this.$apis.agentMgr.get(this.currentUser.sn).then(response => {
        this.agent = response.data
        this.agentLocation = [this.agent.provinceCode, this.agent.cityCode, this.agent.countyCode]
      })
    },
    saveAgent() {
      if (!this.agent.companyName) {
        this.$message.error('请输入公司名称')
        return
      }
      if (!this.agent.name) {
        this.$message.error('请输入姓名')
        return
      }
      if (!this.agent.phone) {
        this.$message.error('请输入手机号')
        return
      }
      if (!this.agentLocation || !this.agent.address) {
        this.$message.error('请输入地址')
        return
      }
      this.$apis.agentMgr.edit(this.agent).then(response => {
        if (response.status === 200) {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
        }
      })
    },
    locationChangeHandler() {
      const node = this.$refs['location'].getCheckedNodes()
      this.agent.provinceCode = node[0].pathValues[0]
      this.agent.provinceName = node[0].pathLabels[0]
      this.agent.cityCode = node[0].pathValues[1]
      this.agent.cityName = node[0].pathLabels[1]
      this.agent.countyCode = node[0].pathValues[2]
      this.agent.countyName = node[0].pathLabels[2]
    },
    locationLazyLoad(node, resolve) {
      let _that = this
      if (node.level === 0) {
        _that.$apis.common.provinces().then(response => {
          const provinces = response.data
          let nodes = []
          provinces.forEach(item => {
            nodes.push({
              value: item.code,
              label: item.name,
              leaf: false
            })
          })
          resolve(nodes)
        })
      } else if (node.level === 1) {
        _that.$apis.common.cities(node.value).then(response => {
          const cities = response.data
          let nodes = []
          cities.forEach(item => {
            nodes.push({
              value: item.code,
              label: item.name,
              leaf: false
            })
          })
          resolve(nodes)
        })
      } else {
        _that.$apis.common.counties(node.value).then(response => {
          const counties = response.data
          let nodes = []
          counties.forEach(item => {
            nodes.push({
              value: item.code,
              label: item.name,
              leaf: true
            })
          })
          resolve(nodes)
        })
      }
    }
  },
  created() {
    this.get()
    this.agentLocations = {
      lazy: true,
      lazyLoad: this.locationLazyLoad
    }
  }
}
</script>

<style scoped>

</style>